export default __webpack_public_path__ + "static/media/0132.2dbc70a9.jpg";